import React, { useState, useEffect, useRef } from 'react';
import IExternalUserTaskReport from '@Shared.Angular/@types/core/contracts/queryModel/reports/maintenance/externalUserTaskReport';
import ClipboardCopy from '@Shared.Angular/flowingly.components/ClipboardCopy/ClipboardCopy';

type ExternalUserTaskUsageReportProps = {
  data: IExternalUserTaskReport[];
};

export const ExternalUserTaskUsageReport = ({
  data
}: ExternalUserTaskUsageReportProps) => {
  const [clipboard, setClipboard] = useState<string>('');
  const tableRef = useRef<HTMLTableElement>(null);

  useEffect(() => {
    if (!data) {
      return;
    }

    setTimeout(() => {
      if (tableRef.current) {
        setClipboard(tableRef.current.outerHTML);
      }
    }, 100);
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <>
      <ClipboardCopy copyText={clipboard} />

      <table id="external-user-task-usage-report" ref={tableRef}>
        <thead>
          <tr>
            <th>Business</th>
            <th className="flow-model-header">
              Flow Models with External User Task
            </th>
            <th>Flows Started</th>
            <th>Recipient Emails</th>
            <th>Recipient Emails Violating Policy</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.businessName}</td>
              <td>{row.activeWorkflowsCount}</td>
              <td>{row.flowsStarted}</td>
              <td className="fixed-width-column">{row.recipientEmails}</td>
              <td className="fixed-width-column">
                {row.externalBusinessDomainEmails}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
